import styled from 'styled-components'
import { FlatButton } from '@sketch/components'

export const BannerButton = styled(FlatButton)`
  padding: 0;
  text-decoration: underline;
`
